<template>
  <button :class="className" :disabled="isLoading" :title="title" type="button" @click="addToCart">
    <slot></slot>
    <span>{{ this.title }}</span>
  </button>
</template>

<script>
export default {
  props: {

    title:          {
      type: String
    },
    className:      {
      type:    String,
      default: 'btn btn--icon btn--red mb-0',
    },
    productId:      {
      type: Number
    },
    selectQuantity: {
      type:    Number,
      default: 1
    },
    in18:           {
      type: Object,
    }
  },
  data() {
    return {
      isLoading: false,
    };
  },
  computed: {
    isShowProductModal: {
      get: function get() {
        return this.$store.getters.isShowProductModal;
      },
      set: function set(value) {
        this.$store.commit('SET_IS_SHOW_PRODUCT_MODAL', value);
      }
    },
  },
  methods:  {
    addToCart() {

      if (this.isLoading) {
        return;
      }

      this.isLoading = true;

      axios.post(`/api/cart-item/add/${this.productId}?action=plus`, {
        'quantity': this.selectQuantity
      }).then((response) => {
        this.cart = response.data.cart;
        this.isShowProductModal = true;
        $('#cart-items-count').text(response.data.cart.total_quantity);

        ga_add_to_cart_event(
          response.data.cart,
          response.data.cart.items.find(item => item.product.id === this.productId),
          this.selectQuantity
        );

      }).catch((error) => {
        window.toastr.error(error.response.data.message);
      }).finally(() => {
        this.isLoading = false;
      });
    },
  },
};
</script>